import { FlagcardAction, FlagcardState } from './types'

const reducer = (
  state: FlagcardState,
  action: FlagcardAction
): FlagcardState => {
  switch (action.type) {
    case 'ADD_FLAGCARD':
      return [...state, action.payload]
    case 'REMOVE_FLAGCARD':
      return state.filter((data) => data.id !== action.payload)
    default:
      return state
  }
}

export default reducer
